import { Routes } from '@angular/router';
import { PlanContainerComponent } from './containers/plan-container/plan-container.component';

export const planRoutes: Routes = [
    {
        path:       '',
        component:  PlanContainerComponent
    },
];
